<template>
    <!-- eslint-disable -->
    <div
        class="mobile-general-form-html-content"
        :class="[`uuid-${config.uuid}`, props.removeWrapStyle && 'not-wrap-style']"
        v-show="!props.hide"
        v-bind="props.attrs"
        v-html="htmlStr"
    ></div>
    <!-- eslint-enable -->
</template>
<script>
import ComponentBase from '../component-base';
import { component } from './props';
import { filterXSS } from '../../utils';

export default {
    name: component,
    extends: ComponentBase,
    computed: {
        htmlStr() {
            let str = typeof this.props.html === 'string' ? this.props.html : '';
            if (this.props.groupTitle) {
                str = str.replace(/GROUP_TITLE/gm, this.props.groupTitle);
            }
            if (!str || !this.props.i18nPattern) {
                return filterXSS(str);
            }
            // 多语言处理
            const i18nPattern = new RegExp(this.props.i18nPattern, 'g');
            str = str.replace(i18nPattern, i18nKey => this.i18n(i18nKey));
            // 发现多语言文案中会用\n表示换行
            str = str.replace(/\n/gm, '<br />');
            return filterXSS(str);
        },
    },
    methods: {
        /**
         * 以下是组件公共方法的实现
         */
        // 无
    },
};
</script>
<style lang="less" scoped>
.mobile-general-form-html-content:not(.not-wrap-style) {
    // margin: 16px;
    padding: 16px;
    background: #fff;
    /deep/ p {
        margin-top: 0;
        &:last-child {
            margin-bottom: 0;
        }
    }
}
.mobile-general-form-html-content {
    /deep/ .group-title {
        box-sizing: border-box;
        height: 38px;
        width: 100%;
        color: var(--font-desc, #666);
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        padding: 18px 19px 0 19px;
        max-width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}
</style>
